import React, { useState } from 'react';

const NAV_LINKS = [
  { href: '/#soluciones-integrales', label: 'Soluciones' },
  { href: '/#servicios', label: 'Servicios' },
  { href: '/#soluciones', label: 'Integración' },
  { href: '/#preguntas', label: 'Preguntas' },
  { href: '/#noticias', label: 'Noticias' },
  { href: '/#casos', label: 'Casos de Éxito' },
  { href: '/#contacto', label: 'Contacto' },
  { href: '/convertidor', label: 'Convertidor VUCEM' },
];

const LayoutHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 dark:border-gray-800 dark:bg-gray-950/95 dark:supports-[backdrop-filter]:bg-gray-950/60">
      <div className="container mx-auto flex h-16 items-center justify-between gap-6 px-4 md:px-6">
        <a href="/" className="flex shrink-0 items-center gap-3" aria-label="EC-Compliance inicio">
          <img src="/favicon.png" alt="EC-Compliance" className="h-10 w-10 shrink-0" />
          <span className="flex flex-col leading-none">
            <span className="whitespace-nowrap text-lg font-bold text-gray-900 dark:text-gray-100">EC-Compliance</span>
            <span className="mt-1 whitespace-nowrap text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Comercio Exterior
            </span>
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-6">
          {NAV_LINKS.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className="whitespace-nowrap text-sm font-medium text-gray-700 hover:text-indigo-700 transition-colors duration-300 ease-in-out hover:underline underline-offset-4 dark:text-gray-300 dark:hover:text-teal-500"
            >
              {label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          className="lg:hidden text-gray-700 dark:text-gray-300"
          aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {menuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </>
            ) : (
              <>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </>
            )}
          </svg>
        </button>
      </div>
      {menuOpen && (
        <nav className="lg:hidden flex flex-col border-t border-gray-200 bg-white px-4 py-2 dark:border-gray-800 dark:bg-gray-950">
          {NAV_LINKS.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              onClick={() => setMenuOpen(false)}
              className="py-2 text-sm font-medium text-gray-700 hover:text-indigo-700 dark:text-gray-300 dark:hover:text-teal-500"
            >
              {label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default LayoutHeader;
